import styled from "styled-components";

export const DirectoryWrapper = styled.div`
  padding: 24px;
  width: 100%;
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ToolbarRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  flex-shrink: 0;
  gap: 12px;
  flex-wrap: wrap;
`;

export const TableContainer = styled.div`
  flex: 1;
  overflow: auto;
  min-height: 0;

  .ant-form-item {
    margin-bottom: 0;
  }
`;

export const StatsRow = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  flex-shrink: 0;
`;

export const StatCard = styled.div`
  background: white;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  min-width: 140px;
  flex: 1;
`;

export const SecondaryName = styled.div`
  color: #999;
  font-size: 12px;
`;

export const Blank = styled.span`
  color: #bbb;
`;
